import client from "/src/services/client";

export default {
    getUserLogs: (userId, params = {}) =>
        client.get(`http-logs`, {
            ...params,
            user_id: userId,
            term: params.term || "",
        }),
    getCompanyLogs: (companyId, params = {}) =>
        client.get(`http-logs`, {
            ...params,
            company_id: companyId,
            term: params.term || "",
        }),
};
